import { useMemo, useState } from "react";
import { galleryTabs, latestAlbums } from "@/mocks/gallery";
import AlbumCard from "@/components/feature/AlbumCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function LatestGallery() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? latestAlbums : latestAlbums.filter((a) => a.category === active)),
    [active],
  );

  return (
    <section id="latest" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Latest Drops"
          title="最新更新"
          desc="本周新整理的写真合集，可在下方按类别标签快速切换，所有内容都能在本页直接浏览，无需跳转。"
        />

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {galleryTabs.map((tab) => {
            const isActive = active === tab;
            return (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                aria-pressed={isActive}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-200 bg-background-100 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {tab}
              </button>
            );
          })}
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {list.map((album) => (
              <AlbumCard key={album.id} album={album} />
            ))}
          </div>
        ) : (
          <p className="mt-10 text-center text-sm text-foreground-500">
            该类别暂时没有新的合集，试试其他标签吧。
          </p>
        )}
      </div>
    </section>
  );
}